import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";

import HomePage from "./routes/home";
import ComplianceProgramsPage from "./routes/compliance-programs";
import ControlsPage from "./routes/controls";
import SubprocessorsPage from "./routes/subprocessors";
import DeliverablesPage from "./routes/deliverables";
import FedRAMP20xLowPage from "./routes/fedramp-20x-low";
import FedRAMPRev5HighPage from "./routes/fedramp-rev-5-high";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/compliance-programs" element={<ComplianceProgramsPage />} />
        <Route path="/controls" element={<ControlsPage />} />
        <Route path="/subprocessors" element={<SubprocessorsPage />} />
        <Route path="/deliverables" element={<DeliverablesPage />} />
        <Route path="/fedramp-20x-low" element={<FedRAMP20xLowPage />} />
        <Route path="/fedramp-rev-5-high" element={<FedRAMPRev5HighPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
